<template>
  <div class="add-a-year">
    <div class="add-a-year__pill">{{ pillText }}</div>
    <div class="add-a-year__text">
      <h3 class="add-a-year__text-title">
        {{ titleText }}
      </h3>
      <span class="add-a-year__text-explain">{{ descriptionText }}</span>
    </div>
    <div class="add-a-year__expiration">
      <div class="add-a-year__expiration-label">New Renewal date:</div>
      <div class="add-a-year__expiration-date">
        {{ expirationDateFirstPart }},&nbsp;
        <span class="add-a-year__expiration-date--crossed">
          {{ expirationDateYear }} </span
        >&nbsp;{{ expirationDateYear + 1 }}
      </div>
    </div>
    <a @click="$emit('open-modal')" class="add-a-year__button btn btn--primary">
      {{ buttonText }}
    </a>
  </div>
</template>
<script>
import { format } from 'date-fns'

export default {
  name: 'AddYearBanner',
  props: {
    promotion: {
      type: Object,
      required: true,
    },
    target: {
      type: String,
      required: true,
    },
  },
  computed: {
    content() {
      return this.promotion ? this.promotion.content : {}
    },
    expirationDateFirstPart() {
      if (!this.content.renews_at) return
      return format(new Date(this.content.renews_at), 'LLL d')
    },
    expirationDateYear() {
      if (!this.content.renews_at) return
      return parseInt(format(new Date(this.content.renews_at), 'yyyy'))
    },
    isForPremium() {
      return this.target === 'premium'
    },
    pillText() {
      return this.isForPremium
        ? `Head into 2022 with 22% off`
        : `1 Year of Premium for $584.22!`
    },
    titleText() {
      return this.isForPremium
        ? `Add 1 year to your Premium subscription for only $584.22!`
        : `Head into 2022 with 22% off! Upgrade to Premium + add a year for only $584.22!`
    },
    buttonText() {
      return this.isForPremium ? ' Add 1 Year' : 'Upgrade now'
    },
    descriptionText() {
      return this.isForPremium
        ? 'Continue your training journey with access to all Learning Areas, interactive labs, and Bootcamps by adding 1 year to your Premium subscription at a 22% savings'
        : 'Enjoy access to all our Learning Areas, interactive labs, and Bootcamps with a Premium Subscription!'
    },
  },
  created() {
    const main = document.querySelector('main')
    main.classList.add('main__add-a-year-banner')
  },
  destroyed() {
    const main = document.querySelector('main')
    main.classList.remove('main__add-a-year-banner')
  },
}
</script>
<style lang="scss" scoped>
.add-a-year {
  display: flex;
  min-height: 100px;
  z-index: 300;
  top: 0;
  right: 0;
  background: linear-gradient(
    104.99deg,
    rgba(62, 63, 73, 0.7) -13.91%,
    rgba(62, 63, 73, 0) 100.48%
  );
  background-size: cover;
  left: 0;
  align-items: center;
  justify-content: space-between;
  background-image: url('../../../assets/images/promotions/add-year-mobilebanner.png');
  background-position: center;
  margin-top: 94px;
  flex-wrap: wrap;
  padding: 30px 20px;
  &__pill {
    padding: 9px 14px;
    background: linear-gradient(89.99deg, #863ad2 3.58%, #5936e4 97.14%);
    border-radius: 20px;
    color: var(--white);
    text-transform: uppercase;
    font-size: 12px;
    line-height: 14px;
    margin-bottom: 20px;
    white-space: nowrap;
  }
  &__text {
    margin-right: auto;
    width: 100%;
  }

  &__text-title {
    font-weight: bold;
    font-size: 20px;
    line-height: 26px;
    display: flex;
    align-items: center;
    color: #ffffff;
    margin: 0;
    margin-bottom: 20px;
  }

  &__text-explain {
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;

    color: #ffffff;
    margin-bottom: 20px;
    max-width: 450px;
  }

  &__expiration-label {
    font-size: 12px;
    line-height: 14px;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    opacity: 0.7;
    color: #ffffff;
    margin-bottom: 5px;
    white-space: nowrap;
  }

  &__expiration {
    width: 100%;
    margin-bottom: 20px;
  }

  &__expiration-date {
    font-weight: normal;
    font-size: 18px;
    line-height: 24px;
    display: flex;
    align-items: center;
    color: #ffffff;
    white-space: nowrap;
    &--crossed {
      position: relative;
      &:before {
        content: '';
        position: absolute;
        transform: rotate(-165deg);
        width: 45px;
        height: 2px;
        top: 12px;
        background: #ff5e5e;
        left: -1px;
      }
      &:after {
        content: '';
        position: absolute;
        transform: rotate(164deg);
        width: 45px;
        height: 2px;
        top: 12px;
        background: #ff5e5e;
        left: -1px;
      }
    }
  }
  &__button {
    white-space: nowrap;
  }
  @include mobile {
    &__expiration {
      margin-right: auto;
      width: auto;
      margin-bottom: 0;
    }
  }
  @include tablet {
    position: fixed;
    margin-top: 0;
    background-image: url('../../../assets/images/promotions/add-year-tabletbanner.png');
    flex-wrap: nowrap;
    padding: 0;
    &__pill {
      margin-left: 70px;
      margin-bottom: 0;
    }
    &__text {
      margin-left: 20px;
      width: auto;
    }
    &__text-title {
      margin: 0;
    }
    &__text-explain {
      opacity: 0.7;
      margin-bottom: 0px;
      max-width: 100%;
    }
    &__expiration {
      margin-left: auto;
      margin-right: 20px;
    }
    &__expiration-label {
      opacity: 1;
      margin-bottom: 0;
    }
    &__button {
      margin-right: 65px;
    }
  }
  @include desktop {
    position: fixed;
    margin-top: 0;
    background-image: url('../../../assets/images/promotions/add-year-tabletbanner.png');
  }
}
</style>
